import { FC } from 'react'
import { useQuery } from 'react-query'
import { fetchPostById } from 'src/services'
import Loading from 'src/components/Loading/Loading'
import Layout from 'src/containers/Layout/Layout'
import PostContainer from 'src/containers/Post/PostDetail'
import { Category } from 'src/types'
import { ids } from 'src/shared/constants'

const ContactPage: FC = () => {
  const { data: post, isFetching, isLoading } = useQuery('contact', () =>
    fetchPostById(ids[Category.Contact]),
  )
  if (isFetching || isLoading || !post) return <Loading />
  return (
    <Layout>
      <PostContainer post={post} hidePV />
    </Layout>
  )
}

export default ContactPage
